<template>
  <div class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">パスワードをリセットする</h2>
      <div class="login-block">
        <div
          v-if="completed"
          class="form-complete-area">
          <div class="form-complete-area__title">パスワードリセットを受け付けました。</div>
          <div class="form-complete-area__lead">
            確認メールを送信しました<br>
            <br>メール内のリンクをクリックして、パスワードリセットを完了させてください。
          </div>
          <div class="form-complete-area__text">＊受信しない場合は迷惑メールフォルダもご確認ください。</div>
        </div>
        <div v-else>
          登録メールアドレスを入力して下さい。
          <form
            :class="{ 'form--error': errorMessage.length > 0 }"
            @submit.prevent="submitForm">
            <div class="form-wrap">
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="username">
                    メールアドレス
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="username"
                    v-model="email"
                    class="form-control"
                    :disabled="loading"
                    type="email"
                    name="username"
                    placeholder="例）sample@example.com">
                  <p
                    v-if="errorMessage"
                    class="error-text">
                    {{ errorMessage }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-btn-area">
              <button
                class="c-btn"
                name="submit"
                type="button"
                :disabled="loading"
                @click.prevent="submitForm">
                パスワードリセットのメールを送信
                <span class="c-btn__icon-arrow" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      completed: false,
      loading: false,
      email: '',
      errorMessage: '',
    }
  },

  methods: {
    async submitForm() {
      this.errorMessage = ''
      this.loading = true

      try {
        await window.axios.post('/api/client/send-reset-password', { email: this.email })

        this.loading = false
        this.completed = true
      } catch (err) {
        this.loading = false

        if (err.response.status === 422) {
          this.errorMessage = 'メールアドレスが見つかりません。'
        }
      }
    },
  },
}
</script>
